import axios from 'axios'

const baseUrl = '/oneview/bff/v1/api/';
export default {
    getAccountType(jwt) {
        return axios.get(baseUrl + 'profile/getAccountType', {headers: {Authorization: "Bearer " + jwt, 'Content-Type': 'application/json'}})
            .then(response => {
                    return response.data
                }
            )
    },
  loginUser(ssoTokenData) {
    return axios.post(baseUrl + 'tWebUtils/loginBySSO', ssoTokenData)
    .then(response => {
          return response.data.accessToken
      }
    )
  },
    setLanguage(language) {
        axios.defaults.headers.common['x-oneapplang'] = language
    },
    getAvailableUsers(token) {
        return axios.get(baseUrl + 'prolongation/getAvailableUsers', {headers: {Authorization: "Bearer " + token, 'Content-Type': 'application/json'}})
            .then(response => {
                    return response.data
                }
            )
    },
}